import { render, staticRenderFns } from "./appConfig.vue?vue&type=template&id=104dde58&scoped=true"
import script from "./appConfig.vue?vue&type=script&lang=js"
export * from "./appConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104dde58",
  null
  
)

export default component.exports